module.exports = __webpack_public_path__ + "static/img/food-policy032.764890e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/food-policy032.png
// module id = vQxO
// module chunks = 1